import { useQuery } from '@tanstack/react-query';
import { getPharmDashboardService } from '../../../domains/pharmDashboard';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

export const useActionRequiredKpi = (brn: string | null | undefined) => {
  return useQuery({
    queryKey: ['action-required-kpi', brn],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getPharmDashboardService().getActionRequiredKpi();
      if (!isResultOk(res)) return null;
      return res?.data ?? null;
    },
  });
};
